// Relocated home is @vestra/agent-sdk (contract/ability-frontmatter.ts) — the
// frontmatter contract lives beside the synthesis emitters it constrains.
// Named re-exports keep the @bash/shared/abilities surface stable without
// leaking the whole SDK into this subpath (same pattern as synthesize.ts).
export type {
  AgentFrontmatter,
  FrontmatterIssue,
  FrontmatterIssueCode,
  FrontmatterSplit,
  NormalizeInput,
  NormalizeMode,
  NormalizeResult,
  NormalizedAbilityItem,
  SkillFrontmatter,
} from '@vestra/agent-sdk';
export {
  DESCRIPTION_HARD_MAX,
  DESCRIPTION_HARD_MIN,
  DESCRIPTION_QUALITY_MIN,
  FRONTMATTER_HARD_MAX,
  KNOWN_AGENT_METADATA_KEYS,
  KNOWN_SKILL_METADATA_KEYS,
  RESERVED_METADATA_KEYS,
  agentMetadataSchema,
  assessDescriptionQuality,
  firstProseParagraph,
  normalizeAgentSource,
  normalizeSkillSource,
  skillMetadataSchema,
  splitFrontmatterBlock,
  stripKnownBoilerplate,
} from '@vestra/agent-sdk';
